import { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

const Portal: FC<Record<string, never | ReactNode>> = ({ children }) => {
  const mountPoint = document.getElementsByClassName('modal')[0];

  return createPortal(children, mountPoint);
};

export default Portal;
